import { navigate } from 'gatsby'
import { tableFromIPC } from '@uwdata/flechette'
import { fromArrow } from 'arquero'

import { hasWindow } from 'util/dom'

export const fetchJSON = async (url, method = 'GET', params = {}) => {
  const response = await fetch(url, {
    method,
    credentials: 'include',
    mode: 'cors',
    ...params,
  })

  if (response.status === 401) {
    const redirURL = hasWindow
      ? `?redir=${window.location.pathname}&showMessage=1`
      : ''
    navigate(`/login/${redirURL}`)
  }

  if (response.status === 404) {
    // 404 errors already log to console
    return null
  }

  if (!response.ok) {
    throw new Error(`Error getting JSON for url ${url}: ${response.statusText}`)
  }

  try {
    const json = await response.json()
    return json
  } catch (error) {
    throw new Error(`Invalid JSON from url ${url}: ${error.message}`)
  }
}

export const fetchFeather = async (url) => {
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors',
  })

  if (response.status === 401) {
    const redirURL = hasWindow
      ? `?redir=${window.location.pathname}&showMessage=1`
      : ''
    navigate(`/login/${redirURL}`)
  }

  if (response.status === 404) {
    // 404 errors already log to console
    return {
      table: null,
      metadata: null,
    }
  }
  if (!response.ok) {
    throw new Error(
      `Error getting Feather data for url ${url}: ${response.statusText}`
    )
  }

  const buffer = new Uint8Array(await response.arrayBuffer())
  const arrowData = tableFromIPC(buffer)
  const table = fromArrow(arrowData)

  return {
    table,
    metadata: arrowData.schema.metadata,
  }
}
